import { render } from "./WeekSchedule.vue?vue&type=template&id=60e4f1e8&scoped=true&ts=true"
import script from "./WeekSchedule.vue?vue&type=script&lang=ts"
export * from "./WeekSchedule.vue?vue&type=script&lang=ts"

import "./WeekSchedule.vue?vue&type=style&index=0&id=60e4f1e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e4f1e8"]])

export default __exports__